import { setHeaderScripts } from './headerScripts'

export { setHeaderScripts }
